<div class="card" *ngIf="report.hourUsagePerformance && report.ampHourPerformance">
	<h3>{{"average_daily_usage.average_daily_usage" | translate}}</h3>

	<div class="weeks">
		Weeks of Operation: <strong>{{ weeksOfOperation }}</strong>
	</div>

	<h4 class="sub-title">{{"average_daily_usage.hour_usage_performance" | translate}}</h4>

	<div class="donut" [ngStyle]="{ background: hourGradient }">
		<div class="donut-center">
		<div class="big">{{report.hourUsagePerformance[period]?.DailyHoursPercent}}%</div>
		<div>{{"average_daily_usage.daily_hours" | translate}}</div>
		</div>
	</div>

	<div class="legend">
		<div class="legend-row">
		<div class="left"><span class="blue"></span>{{"average_daily_usage.in_Use" | translate}}</div>
		<div>{{ report.hourUsagePerformance[period]?.inUse.value }}</div>
		</div>

		<div class="legend-row">
		<div class="left"><span class="green"></span>{{"average_daily_usage.charge" | translate}}</div>
		<div>{{ report.hourUsagePerformance[period]?.charge.value }}</div>
		</div>

		<div class="legend-row">
		<div class="left"><span class="gray"></span>{{"average_daily_usage.idle" | translate}}</div>
		<div>{{ report.hourUsagePerformance[period]?.idle.value }}</div>
		</div>
	</div>

	<hr />

	<h4 class="sub-title">{{"average_daily_usage.amp_hour_performance" | translate}}</h4>

	<div class="donut" [ngStyle]="{ background: ampGradient }">
		<div class="donut-center">
		<div class="big">{{ ampReturnPercent }}%</div>
		<div>Returned</div>
		</div>
	</div>

	<div class="amp-bars">
		<div class="amp-row" *ngFor="let bar of ampBars">
		<div class="legend">
			<div class="legend-row">
			<div class="left"><span [class]="bar.color"></span>{{ bar.label }}</div>
			<div>{{ bar.value }}</div>
			</div>
		</div>

		<div class="progress">
			<div [class]="'progress-fill ' + bar.color" [style.width.%]="bar.percent"></div>
		</div>
		</div>
	</div>
</div>
